import(/* webpackMode: "eager", webpackExports: ["SWRConfig"] */ "/opt/build/repo/app/_providers/SWRConfig.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageContainer"] */ "/opt/build/repo/components/layout/Layout/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/pages/HowToBuy/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/site/NotFound/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
